$(document).ready(function () {
    $('.tab-projects select').on('change', function () {
        var projectId = $(this).data('project-id');
        const shouldUpdateStatus = $(this).data('update-status');

        var projectTypeStatusId = $("option:selected", this).data('project-type-status-id');
        var action = $("option:selected", this).data('action');
        var actionTitle = $("option:selected", this).data('action-title');
        var actionOptionalParams = $("option:selected", this).data('action-optional-params');

        let actionRoute = "/admin/projects/"+projectId+'/'+action+'/'+projectTypeStatusId;
        if (actionOptionalParams !== undefined && actionOptionalParams !== '') {
            actionRoute += '/'+actionOptionalParams;
        }


        if (action !== undefined && action != '') {
            window.sidePanels.open($('#data-side-panel-project-type-status-action'), actionRoute);
            window.sidePanels.getCurrentSidePanel().find('.card-header').find('div:first').html(actionTitle);
        }

        var statusId = $(this).val();

        var customerIcon = $(this).closest('tr').find('.customer-icon');
        var statusCells = $(this).closest('tr');
        var statusColor = $("option:selected", this).data('color');
        let statusTextColor = $("option:selected", this).data('text-color');

        customerIcon.html('<i class="fas fa-spinner fa-spin"></i>');

        if (shouldUpdateStatus === undefined || shouldUpdateStatus === '') {
            $.get("/admin/projects/"+projectId+'/set-status/'+statusId, function () {
                customerIcon.html('<i class="fas fa-check text-success"></i>');
                setTimeout(function() {
                    customerIcon.html('');
                    $(this).find('td').each (function() {
                        // do your cool stuff
                    });
                    statusCells.find( "td" ).css( "background-color", statusColor );
                    statusCells.find( "td" ).css( "color", statusTextColor );
                    statusCells.find( "button" ).css( "background-color", statusColor );
                }, 800);
            }).fail(function () {
                customerIcon.html('<i class="fas fa-exclamation-triangle text-danger"></i>');
            });
        }
    });

    $('.tab-projects .project-information').on('change', function () {
        var projectId = $(this).closest('tr').data('project-id');

        var url = '/admin/projects/'+projectId+'/save-information'
        $.post(url, {
            information: this.value,
        }).done(function (data) {

        });
    });

    function findUnderlyingIbProject(yearwork) {
        if (yearwork.length === 0) {
            return;
        }

        var projectId = $(this).closest('tr').data('project-id');
        $.get('projects/find-ib-projects', function (data) {
            // if data.projects is a non-empty array
            if (data.projects.length > 0) {
                confirm("Er is een onderliggend IB project gevonden. Wilt u de planningsdatum van 'Voorbereiding' en 'Aangifte' automatisch aanpassen?", function () {
                    // if project system_name = 'ib_preparation'
                    // then set value to planned_at - 1 month
                    for (var i = 0; i < data.projects.length; i++) {
                        if (data.projects[i].system_name === 'ib_preparation') {
                            let newValue = new Date(yearwork.val());
                            let originalDay = newValue.getDate();
                            newValue.setMonth(newValue.getMonth() - 1);

                            // Check if the day has changed due to overflow
                            if (newValue.getDate() !== originalDay) {
                                // Move to the last day of the previous month
                                newValue.setDate(0);
                            }

                            newValue = newValue.toISOString().split('T')[0];

                            planAhead(data.projects[i].id, newValue);
                        } else if (data.projects[i].system_name === 'declaration') {
                            planAhead(data.projects[i].id, yearwork.val());
                        }
                    }
                });
            }
        });
    }

    function planAhead(projectId, value) {
        var url = '/admin/projects/'+projectId+'/save-planned'
        $.post(url, {
            planned_at: value,
        }).done(function (data) {

        });
    }

    $('.tab-projects .project-planned-at').on('change', function () {
        var value = this.value;
        var projectId = $(this).closest('tr').data('project-id');
        var yearwork = $(this).closest('tr').find('td input.yearwork');

        planAhead(projectId, value);
        findUnderlyingIbProject(yearwork);
    });

    $('.tab-projects .project-employee').on('change', function () {
        const projectId = $(this).closest('tr').data('project-id');
        $.post('/admin/projects/'+projectId+'/update-employee', {
            user_id: this.value,
        });
    });

    $('#estimate').on('change', function () {
        var dossierId = $(this).data('dossier-id');
        var year = $(this).data('dossier-year');

        var url = '/admin/dossiers/'+dossierId+'/save-estimate'
        $.post(url, {
            estimate: this.value,
            year: year
        }).done(function (data) {

        });
    });

    $('.dossier-year-info').on('change', function () {
        var dossierId = $(this).data('dossier-id');
        var year = $(this).data('dossier-year');
        var type = $(this).data('type');

        var url = '/admin/dossiers/'+dossierId+'/save-year-information'
        $.post(url, {
            info: this.value,
            type: type,
            year: year
        }).done(function (data) {

        });
    });
});
